export default __webpack_public_path__ + "static/media/grayPoint.babe45a7.png";